import './ProductCoveWithMetadata.scss';
import Strings from "../../config/Strings";
import radioplay from "../../../assets/images/search/radioplay.svg";
import audiobook from "../../../assets/images/search/audiobook.svg";
import music from "../../../assets/images/search/music.svg";
import podcast from "../../../assets/images/search/microphone-solid-full.svg";
import playlist from "../../../assets/images/search/playlist.svg";
import {getProductLength} from "../search/SearchService";
import React from "react";
import logo from "../../../assets/images/loader_bg.png";

export default function ProductCoverWithMetadata(props) {
    const {product} = props;
    const coverUrl = product.cover != null ? (
        product.cover.contentLocation != null ? (
            product.cover.contentLocation.location != null ? product.cover.contentLocation.location : logo
        ) : logo
    ) : (
        product._links != null ? (product._links.cover != null ? (product._links.cover.href != null ? product._links.cover.href : logo) :logo)
            :
            logo);

    return (
        <div className="product-metadata-cover">
            <div className="product-metadata-cover-background-container">
                {product.ageMin != null &&
                    <div className="cover-age-display"
                         dangerouslySetInnerHTML={{__html: Strings.SEARCH_ITEM_AGE.replace("{0}", product.ageMin)}}/>
                }
                {product.productClassification === 'RADIOPLAY' &&
                    <img src={radioplay} className="cover-product-classification-display" alt={"radioplay"}/>
                }
                {product.productClassification === 'AUDIOBOOK' &&
                    <img src={audiobook} className="cover-product-classification-display" alt={"audiobook"}/>
                }
                {product.productClassification === 'MUSIC' &&
                    <img src={music} className="cover-product-classification-display" alt={"music"}/>
                }
                {product.productClassification === 'PODCAST' &&
                    <img src={podcast} className="cover-product-classification-display" alt={"podcast"}/>
                }
                {product.productClassification === 'PLAYLIST' &&
                    <img src={playlist} className="cover-product-classification-display" alt={"playlist"}/>
                }
                <div className="cover-product-length-display"
                     dangerouslySetInnerHTML={{__html: getProductLength(product)}}/>
            </div>
            <img src={coverUrl} style={{borderRadius: "15px", width: "100%"}}
                 alt={"Titelbild von " + product.title}/>
        </div>
    );


}